import * as _ from 'underscore';

import ACTIONS from './actions';
import CALENDAR_ACTIONS from '../calendar/actions';

const clipboard = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.CLIPBOARD_CANCEL_DELETE_DIALOG:
            return {
                ...state,
                deleteDialogEnabled: false
            };
        case ACTIONS.CLIPBOARD_ENABLE_EXPORT_AS_PROGRAM_MODAL:
            return {
                ...state,
                exportAsProgramModalEnabled: action.isOpen,
                hotkeysArePaused: action.isOpen
            };
        case ACTIONS.CLIPBOARD_CANCEL_REPEAT_MODAL:
            return {
                ...state,
                repeatModalEnabled: false
            };
        case ACTIONS.CLIPBOARD_CLEAR_SELECTED_SESSIONS:
            return {
                ...state,
                selectedSessions: {},
                publishEnabled: false,
                unpublishEnabled: false,
                programExportEnabled: false,
                exportAsProgramModalEnabled: false,
                repeatModalEnabled: false,
                deleteDialogEnabled: false
            };
        case ACTIONS.CLIPBOARD_COPY_SELECTED_SESSIONS:
            return {
                ...state,
                pasteEnabled: !_.isEmpty(action.copiedSessions),
                copiedSessions: action.copiedSessions
            };
        case ACTIONS.CLIPBOARD_ENABLE_DELETE_DIALOG:
            return {
                ...state,
                deleteDialogEnabled: true
            };
        case ACTIONS.CLIPBOARD_ENABLE_REPEAT_MODAL:
            return {
                ...state,
                repeatModalEnabled: true
            };
        case ACTIONS.CLIPBOARD_SELECT_SESSIONS:
            return {
                ...state,
                selectedSessions: action.selectedSessions,
                publishEnabled: action.publishEnabled,
                unpublishEnabled: action.unpublishEnabled,
                programExportEnabled: action.programExportEnabled,
                exportAsProgramModalEnabled: false,
                repeatModalEnabled: false,
                deleteDialogEnabled: false
            };
        case ACTIONS.CLIPBOARD_ENABLE_CALENDAR_HOTKEYS:
            return {
                ...state,
                hotkeysArePaused: false
            };
        case ACTIONS.CLIPBOARD_DISABLE_CALENDAR_HOTKEYS:
            return {
                ...state,
                hotkeysArePaused: true
            };
        case ACTIONS.TOAST:
            return {
                ...state,
                toastMessage: action.toastMessage,
                toastType: action.toastType
            };
        case CALENDAR_ACTIONS.UI_BASIC_DRAWER:
            return {
                ...state,
                hotkeysArePaused: !action.drawerOpen
            };
        default:
            return state;
    }
};

export default clipboard;



// WEBPACK FOOTER //
// ./src/state/reducer/clipboard/reducer.js